import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { FormattedMessage } from "react-intl";

/**
 * Nadpisujemy style dla komponentu select, aby dopasowac do zwyklego inputa i zlikwidowac ramke
 */
const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderWidth: "0px",
    borderBottom: "1px solid #ccc"
  })
};

class RestaurantView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      restaurant: this.props.restaurant,
      selectedNetworks: this.props.networkList.filter(item => {
        return this.props.restaurant.networkIds.includes(item.id);
      })
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.onSubmit(this.state.restaurant);
  };

  handleCancel = e => {
    e.preventDefault();
    this.props.onCancel();
  };

  handleInputChange = e => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let restaurant = { ...this.state.restaurant, [name]: value };
    this.setState({ restaurant });
  };

  handleSelectChangeOnNetworks = selectedOption => {
    if (selectedOption && selectedOption.length) {
      let restaurant = {
        ...this.state.restaurant,
        networkIds: selectedOption.map(item => {
          return item.id;
        })
      };
      this.setState({ restaurant });
    } else {
      let restaurant = { ...this.state.restaurant, networkIds: [] };
      this.setState({ restaurant });
    }
    this.setState({ selectedNetworks: selectedOption });
  };

  render() {
    const { selectedNetworks } = this.state;

    return (
      <div className="w3-card-4">
        <div className="w3-container w3-theme">
          <h2 className="w3-center">{this.props.title}</h2>
        </div>

        <form className="w3-container" onSubmit={this.handleSubmit}>
          <div className="w3-row-padding">
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                pattern="[0-9]*"
                title="Nieprawidłowy identyfikator restauracji"
                name="id"
                onChange={this.handleInputChange}
                value={this.state.restaurant.id}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("id")
                }
                required
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.id" defaultMessage="Id" />
              </label>
            </div>
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="nip"
                onChange={this.handleInputChange}
                value={this.state.restaurant.nip}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("nip")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.nip" defaultMessage="nip" />
              </label>
            </div>
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="countryNip"
                onChange={this.handleInputChange}
                value={this.state.restaurant.countryNip}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("countryNip")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.countryNip" defaultMessage="countryNip" />
              </label>
            </div>
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="regon"
                onChange={this.handleInputChange}
                value={this.state.restaurant.regon}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage
                  id="restaurant.regon"
                  defaultMessage="Regon"
                />
              </label>
            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s12">
              <input
                className="w3-input"
                type="text"
                name="name"
                onChange={this.handleInputChange}
                value={this.state.restaurant.name}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage
                  id="restaurant.name"
                  defaultMessage="name"
                />
              </label>
            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s12">
              <input
                className="w3-input"
                type="text"
                name="description"
                onChange={this.handleInputChange}
                value={this.state.restaurant.description}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage
                  id="restaurant.description"
                  defaultMessage="Description"
                />
              </label>
            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s12">
              <input
                className="w3-input"
                type="text"
                name="clientName"
                onChange={this.handleInputChange}
                value={this.state.restaurant.clientName || ""}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage
                  id="restaurant.clientName"
                  defaultMessage="ClientName"
                />
              </label>
            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="country"
                onChange={this.handleInputChange}
                value={this.state.restaurant.country}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("country")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.country" defaultMessage="country" />
              </label>
            </div>
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="province"
                onChange={this.handleInputChange}
                value={this.state.restaurant.province}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("province")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.province" defaultMessage="province" />
              </label>
            </div>
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="district"
                onChange={this.handleInputChange}
                value={this.state.restaurant.district}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("district")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.district" defaultMessage="district" />
              </label>
            </div>

            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="community"
                onChange={this.handleInputChange}
                value={this.state.restaurant.community}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("community")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.community" defaultMessage="community" />
              </label>
            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s6">
              <input
                className="w3-input"
                type="text"
                name="streetName"
                onChange={this.handleInputChange}
                value={this.state.restaurant.streetName}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("streetName")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.streetName" defaultMessage="streetName" />
              </label>
            </div>
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="streetNumber"
                onChange={this.handleInputChange}
                value={this.state.restaurant.streetNumber}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("streetNumber")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.streetNumber" defaultMessage="streetNumber" />
              </label>
            </div>
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="localNumber"
                onChange={this.handleInputChange}
                value={this.state.restaurant.localNumber}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("localNumber")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.localNumber" defaultMessage="localNumber" />
              </label>
            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s6">
              <input
                className="w3-input"
                type="text"
                name="postCode"
                onChange={this.handleInputChange}
                value={this.state.restaurant.postCode}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("postCode")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.postCode" defaultMessage="postCode" />
              </label>
            </div>
            <div className="w3-col s6">
              <input
                className="w3-input"
                type="text"
                name="post"
                onChange={this.handleInputChange}
                value={this.state.restaurant.post}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("post")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.post" defaultMessage="post" />
              </label>
            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="phone1"
                onChange={this.handleInputChange}
                value={this.state.restaurant.phone1}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("phone1")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.phone1" defaultMessage="phone1" />
              </label>
            </div>
            <div className="w3-col s3">
              <input
                className="w3-input"
                type="text"
                name="email"
                onChange={this.handleInputChange}
                value={this.state.restaurant.email}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("email")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.email" defaultMessage="email" />
              </label>
            </div>
            <div className="w3-col s6">
              <input
                className="w3-input"
                type="text"
                name="url"
                onChange={this.handleInputChange}
                value={this.state.restaurant.url}
                disabled={
                  this.props.disableProperties &&
                  this.props.disableProperties.includes("url")
                }
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="restaurant.url" defaultMessage="url" />
              </label>
            </div>
          </div>

          <div className="w3-row-padding w3-margin-top">
            <div className="w3-col s6">
              <Select
                styles={selectStyles}
                isMulti
                value={selectedNetworks}
                name="networkIds"
                onChange={this.handleSelectChangeOnNetworks}
                options={this.props.networkList}
                getOptionLabel={option => option.name}
                getOptionValue={option => option.id}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage
                  id="restaurant.networks"
                  defaultMessage="Networks"
                />
              </label>
            </div>
          </div>

          <div className="w3-bar">
            <button
              className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
              type="submit"
            >
              {this.props.sumbitText}
            </button>
            <button
              className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
              type="reset"
              onClick={this.handleCancel}
            >
              {this.props.cancelText}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

RestaurantView.propTypes = {
  title: PropTypes.string.isRequired,
  restaurant: PropTypes.object.isRequired,
  networkList: PropTypes.array.isRequired,
  cancelText: PropTypes.string.isRequired,
  sumbitText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disableProperties: PropTypes.array
};

export default RestaurantView;
